import * as React from 'react';
import { IconProps } from '../types';

const IcFunctionAddPrice = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
     <g fill={props?.fill ?? '#232F3E'} clipPath="url(#a)">
      <path d="M11.75 7.848c-.936.255-1.5.974-1.5 1.652 0 .679.564 1.397 1.5 1.653V7.848ZM13.25 12.848v3.304c.936-.255 1.5-.974 1.5-1.652 0-.678-.564-1.397-1.5-1.652Z" />
      <path
        fillRule="evenodd"
        d="M24.5 12c0 6.627-5.373 12-12 12S.5 18.627.5 12s5.373-12 12-12 12 5.373 12 12Zm-12-8.1a.9.9 0 0 1 .9.9v.38C15.357 5.53 17 7 17 9a.9.9 0 0 1-1.8 0c0-.814-.677-1.676-1.8-1.983v4.163C15.357 11.53 17 13 17 15c0 2-1.643 3.47-3.6 3.82v.38a.9.9 0 0 1-1.8 0v-.38C9.643 18.47 8 17 8 15a.9.9 0 0 1 1.8 0c0 .814.677 1.676 1.8 1.983V12.82C9.643 12.47 8 11 8 9c0-2 1.643-3.47 3.6-3.82V4.8a.9.9 0 0 1 .9-.9Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5 0h24v24H.5z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcFunctionAddPrice;
